import { render, staticRenderFns } from "./goodscode-add-or-update.vue?vue&type=template&id=76ebabce&scoped=true&"
import script from "./goodscode-add-or-update.vue?vue&type=script&lang=js&"
export * from "./goodscode-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./goodscode-add-or-update.vue?vue&type=style&index=0&id=76ebabce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ebabce",
  null
  
)

export default component.exports